

const ScreenReaderNavigator = (props) => {

    return <a className="sr-only sr-only-focusable" title="Skips to the main content." href="/" onClick={e => {
        e.preventDefault();
        let element = document.querySelector(".main-content input, " + 
            ".main-content button, " + 
            ".main-content select, " +
            ".main-content th, " + 
            ".main-content a[href=\"/\"]");
        if (element)
        {
            element.focus();
        }
    }}>
        Skip to main content
    </a>;
};

export default ScreenReaderNavigator;

export const TabStopAnchor = (props) => {
    return <a style={{ color: "white", cursor: "default", textDecoration: "none" }} href="/" {...props}
        onClick={e => {
            e.preventDefault();
        }}>
        {props.children}
    </a>
};
